import { BillingStrategy } from '@ctct/domain-layer';

import { useBillingStrategy } from './useBillingStrategy';
import { useHidePromoCodesForStripeMultimonthGate } from '../experiments';

export interface UsePromoCodeVisibilityFacadeResult {
  shouldHidePromoCodes: boolean;
  data: boolean;
  isLoading: boolean;
  isError: boolean;
  error: unknown;
}

export const usePromoCodeVisibilityFacade = (paymentPeriod: string | null): UsePromoCodeVisibilityFacadeResult => {
  const featureGate = useHidePromoCodesForStripeMultimonthGate();
  const billingStrategyQuery = useBillingStrategy();

  const isStripeCustomer = billingStrategyQuery.data === BillingStrategy.Stripe;
  const isMultimonthPeriod = paymentPeriod === '6' || paymentPeriod === '12';
  const isFeatureGateEnabled = featureGate.data === true;

  // CBU-20663: Restore promo code visibility for charm pricing customers
  // Promo codes now work as they did before CPD-16991 removed them
  // Only hide for Stripe multimonth customers when gate is enabled
  const shouldHidePromoCodes = isStripeCustomer && isMultimonthPeriod && isFeatureGateEnabled;

  return {
    data: isFeatureGateEnabled,
    shouldHidePromoCodes,
    isLoading: billingStrategyQuery.isPending,
    isError: billingStrategyQuery.isError,
    error: billingStrategyQuery.error,
  };
};
